module.exports = __webpack_public_path__ + "img/palet03.9b73e931.png";